module.exports = __webpack_public_path__ + "static/img/hui-bg.7dc4396.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/pages/home/images/hui-bg.png
// module id = W4WJ
// module chunks = 4